import { ApiIndividualResponse, ApiPaginatedResponse } from './api';
import { ICompany } from './company';
import { DocumentType, IDocumentReference } from './document-reference';
import { IPayment, PaymentStatus } from './payment';
import { IUser } from './user';

export type ApiIndividualPaymentGroup = ApiIndividualResponse<IPaymentGroup>;
export type ApiPaginatedPaymentGroups = ApiPaginatedResponse<IPaymentGroup>;

export interface IPaymentGroup {
  _id: string;
  payments: string[];
  amount: number;
  currency: string;
  method: 'card' | 'bank_transfer';
  status: PaymentStatus;
  stage?: PaymentGroupStage | null;
  createdBy: string;
  payer: IDocumentReference<DocumentType.Company>;
  paymentProvider: 'stripe';
  providerInfo?: {
    checkoutSessionId?: string;
    checkoutSessionUrl?: string;
    fundingIntentId?: string;
    settlementIntentId?: string;
    instructions?: {
      iban: string;
      reference: string;
      bankName?: string;
      amountExpected?: number;
    };
  };
  createdAt: string;
  updatedAt: string;
}

export interface IPaymentGroupWithPayments
  extends Omit<IPaymentGroup, 'payments'> {
  payments: IPayment[];
}

export interface IPaymentGroupWithCreator
  extends Omit<IPaymentGroup, 'createdBy'> {
  createdBy: IUser;
}

export interface IPaymentGroupWithPayer extends Omit<IPaymentGroup, 'payer'> {
  payer: IDocumentReference<DocumentType.Company, ICompany>;
}

export enum PaymentGroupStage {
  AWAITING_PAYMENT = 'awaiting_payment',
  IN_PROGRESS = 'in_progress',
  FAILED = 'failed',
  COMPLETED = 'completed',
}

export interface IPaymentGroupStats {
  stage: string;
  count: number;
}

export enum PaymentGroupType {
  PayIn = 'pay_in',
  PayOut = 'pay_out',
}

export type ApiPaymentGroupStats = ApiIndividualResponse<IPaymentGroupStats[]>;
